import { LOGIN_ADMIN } from '../../fetchTypes';
import { makeFetcher } from './base';

export default (fetchType) => {
  switch (fetchType) {
    case LOGIN_ADMIN:
      return data => makeFetcher('admins/login', 'POST', data);
    default:
      return null;
  }
};
